import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogPortal } from '@/components/ui/dialog'
import { User } from '@/types/user'
import InfoUsuario from './info-usuario'
import { memo, useEffect, useRef } from 'react'

interface Props {
  isOpen: boolean
  onClose: () => void
  user: User | null
}

export default memo(function UserDetailModal({ isOpen, onClose, user }: Props) {
  if (!user) return null

  // Proteção nos primeiros ms pra ignorar eventos “fantasmas”
  const justOpenedRef = useRef(false)
  useEffect(() => {
    if (isOpen) {
      justOpenedRef.current = true
      const id = setTimeout(() => {
        justOpenedRef.current = false
      }, 150)
      return () => clearTimeout(id)
    }
  }, [isOpen])

  // Sanitização defensiva ao fechar
  useEffect(() => {
    if (!isOpen) {
      const id = setTimeout(() => {
        try {
          if (document.body.style.overflow === 'hidden') document.body.style.overflow = ''
          const root = document.getElementById('root') || document.body
          if (root?.getAttribute('aria-hidden') === 'true') root.removeAttribute('aria-hidden')
        } catch {}
      }, 0)
      return () => clearTimeout(id)
    }
  }, [isOpen])

  return (
    <Dialog
      modal={false}
      open={isOpen}
      onOpenChange={open => {
        if (!open) onClose()
      }}
    >
      <DialogPortal container={typeof document !== 'undefined' ? document.body : undefined}>
        {/* Sem Overlay para não bloquear clique fora */}
        <DialogContent
          className="max-w-5xl max-h-[85vh] overflow-y-auto"
          onOpenAutoFocus={e => e.preventDefault()}
          onCloseAutoFocus={e => e.preventDefault()}
          // ✅ Não deixa fechar por clique-fora
          onPointerDownOutside={e => {
            if (justOpenedRef.current) e.preventDefault()
            else e.preventDefault()
          }}
          onInteractOutside={e => {
            if (justOpenedRef.current) e.preventDefault()
            else e.preventDefault()
          }}
          // ✅ Não deixa fechar por ESC (remova se quiser permitir)
          onEscapeKeyDown={e => e.preventDefault()}
        >
          <DialogHeader>
            <DialogTitle>Perfil do usuário</DialogTitle>
          </DialogHeader>

          <InfoUsuario user={user} handleDeleteUser={onClose} />
        </DialogContent>
      </DialogPortal>
    </Dialog>
  )
})
